import { LoadingPage } from '@innovyze/stylovyze';
import React from 'react';

interface Args {
	loading: boolean;
	children: React.ReactNode;
}

export default function RenderComponentOrLoading({ loading, children }: Args) {
	return loading ? <LoadingPage /> : <>{children}</>;
}
